import styled from "styled-components";

export const LiveCasinoGridItemWrapperDefaultBox = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid ${props => props.theme.components.newLiveCasino.colors.gridItem.wrapperBorder};
    border-radius: 3px;
    overflow: hidden;
    box-shadow: 0 0 5px ${props => props.theme.colors.boxBorderDark};

    &:hover {
      cursor: pointer;
     }
`;